<template>
	<el-table
		:data="tableData"
		show-summary
		:summary-method="summaryMethod"
		border
		style="width: 100%"
	>
		<el-table-column
			label="序号"
			align="center"
			width="50"
			type="index"
		></el-table-column>
		<el-table-column
			v-for="(item, index) in state.columnList"
			:key="index"
			:label="item.label"
			:prop="item.prop"
			align="center"
		></el-table-column>
	</el-table>
</template>

<script>
import { reactive } from "vue";

export default {
	props: {
		tableData: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	setup(props) {
		const state = reactive({
			columnList: [
				{ label: "耗材名称", prop: "name" },
				{ label: "单价", prop: "unitPrice" },
				{ label: "数量", prop: "number" },
				{ label: "总计", prop: "price" },
			],
		});
		const summaryMethod = (param) => {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = "总价";
					return;
				}
				const values = data.map((item) =>
					Number(item[column.property])
				);
				if (!values.every((value) => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
				}
			});

			return sums;
		};
		return {
			summaryMethod,
			state,
		};
	},
};
</script>

<style scoped>
</style>
